import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { BlindajeTotal } from './components/BlindajeTotal';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    // Meta Pixel inline initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '2292460911162237');
    f.fbq('track', 'PageView');
  }, []);
  const firstTestimonials = [{
    name: 'Mariana G.',
    location: 'Córdoba',
    text: 'Organicé todos mis protocolos de rodilla en una tarde. Las fichas me ahorran horas cada semana.'
  }, {
    name: 'Lucas P.',
    location: 'Rosario',
    role: 'Clínica Kinesiológica',
    text: 'El protocolo de retorno deportivo por fin tiene sentido. Los tomos de re-educación de carga son el hit de mi consultorio.'
  }, {
    name: 'Roberto M.',
    location: 'Buenos Aires',
    text: 'Mis pacientes de post-cirugía por fin progresan con un sistema claro. El Tomo 5 vale cada peso.'
  }];
  const secondTestimonials = [{
    name: 'Cecilia R.',
    location: 'Mendoza',
    role: 'Atlas + Blindaje Total',
    text: 'El protocolo integrado cadera-rodilla me salvó la vida. Ya no improviso entre articulaciones. Mis pacientes progresan de verdad.'
  }, {
    name: 'Roberto M.',
    location: 'Buenos Aires',
    role: 'Kinesiólogo Deportivo',
    text: 'Con el tracker semáforo, en 5 minutos el paciente entiende dónde está y hacia dónde va. La adherencia al tratamiento mejoró un 100%.'
  }, {
    name: 'Sofía C.',
    location: 'La Plata',
    role: 'Kinesióloga',
    text: 'Mis pacientes de post-cirugía terminaron la rehabilitación en tiempo y forma. Eso no pasaba antes.'
  }, {
    name: 'Pablo A.',
    location: 'Neuquén',
    role: 'Kinesiólogo',
    text: 'El scriptbook de qué decir y qué no decir fue un antes y un después en mi consultorio. Menos abandonos, más resultados.'
  }];
  return <div className="w-full min-h-screen bg-[#0a1410]" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials testimonials={firstTestimonials} data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductOverview data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Pricing data-id="element-6" />
      <BlindajeTotal data-id="element-7" />
      <Testimonials testimonials={secondTestimonials} data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <CostOfInaction data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
      <WhatsAppButton data-id="element-14" />
    </div>;
}